
import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const localSeoTableOfContents: TableOfContentsItem[] = [
  {
    id: "evolucion-seo-local",
    title: "Evolución del SEO Local hacia 2025",
    subItems: [
      { id: "cambios-comportamiento", title: "Cambios en el comportamiento del usuario" },
      { id: "avances-tecnologias", title: "Avances en tecnologías de búsqueda" },
      { id: "impacto-marketing", title: "Impacto del marketing digital en el SEO Local" }
    ]
  },
  {
    id: "posicionamiento-google-maps",
    title: "Importancia del Posicionamiento en Google Maps",
    subItems: [
      { id: "beneficios", title: "Beneficios del posicionamiento" },
      { id: "herramientas", title: "Herramientas de optimización" },
      { id: "mejora-visibilidad", title: "Mejora de la visibilidad local" }
    ]
  },
  {
    id: "geo-positioning",
    title: "Posicionamiento GEO: El Nuevo Paradigma",
    subItems: [
      { id: "geo-vs-local", title: "SEO Local vs GEO" },
      { id: "atlas-chatgpt", title: "Atlas de ChatGPT y Google SGE" },
      { id: "estrategia-combinada", title: "Estrategia SEO Local + GEO" }
    ]
  },
  {
    id: "estrategias-clave",
    title: "Estrategias Clave para Mejorar el SEO Local",
    subItems: [
      { id: "optimizacion-perfil", title: "Optimización del perfil de empresa" },
      { id: "palabras-clave", title: "Investigación de palabras clave" },
      { id: "presencia-online", title: "Construcción de una presencia online sólida" },
      { id: "optimizacion-web", title: "Optimización del sitio web" }
    ]
  },
  {
    id: "tendencias-futuras",
    title: "Tendencias Futuras en el SEO Local",
    subItems: [
      { id: "ia-seo", title: "Uso de inteligencia artificial" },
      { id: "seo-movil", title: "SEO móvil y búsqueda por voz" },
      { id: "experiencia-usuario", title: "Experiencia del usuario como factor clave" },
      { id: "busquedas-sin-clic", title: "Búsquedas sin clic y fragmentos enriquecidos" }
    ]
  },
  {
    id: "herramientas-recursos",
    title: "Herramientas y Recursos para el SEO Local",
    subItems: [
      { id: "herramientas-google", title: "Herramientas de Google para SEO" },
      { id: "aplicaciones-analisis", title: "Aplicaciones y plataformas de análisis" },
      { id: "formacion", title: "Formación y actualización constante" }
    ]
  }
];
